import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-select-by-keys-dropdown',
  templateUrl: './select-by-keys-dropdown.component.html',
  styleUrls: ['./select-by-keys-dropdown.component.scss']
})
export class SelectByKeysDropdownComponent {

  uniqueId: string = uuidv4();

  @Input() dataArray: any[] | undefined = [];

  @Input() selectedKey: any;

  @Input() translateKey: string = "";

  @Input() placeholder: string = "";

  @Input() otherOption = false;

  @Input() loading: boolean = false

  @Input() error: boolean = false;

  @Input() showAbsolute: boolean = true;

  @Input() borderColor: string | null = "hsl(0, 0%, 50%);";
  @Input() borderWidth: string | null = "1px";
  @Input() borderRadius: string | null = "10px";
  @Input() fontSize: string | null = "16px";
  @Input() fontWeight: string | null = "300";

  @Output() optionEmitter = new EventEmitter();

  openDropdown = false;

  otherOptionKey: string = `Other_12345678`
  showOtherOptionInput: boolean = false;

  otherOptionText: string = ""

  private isFirstChange = true;

  ngOnChanges(changes: SimpleChanges) {
    this.setLoadingStatus()
    if (!changes['dataArray']?.firstChange) {
      this.setOtherOptionData();
    }
  }

  setLoadingStatus() {
    if (this.loading) {
      this.openDropdown = false;
      this.showOtherOptionInput = false;
    }
  }

  setOtherOptionData() {
    if (this.otherOption && this.dataArray && !this.loading) {
      if (!this.dataArray.includes(this.otherOptionKey)) {
        this.dataArray.push(this.otherOptionKey);
      }
      if (!this.dataArray.includes(this.selectedKey)) {
        this.otherOptionText = this.selectedKey
        this.showOtherOptionInput = true;
      } else {
        this.showOtherOptionInput = false;
      }
    }
  }

  toggleDropdown() {
    if (!this.loading) {
      this.openDropdown = !this.openDropdown;
    }
  }

  selectOption(event: any) {
    if (this.otherOption && event == this.otherOptionKey) {
      this.showOtherOptionInput = true;
      this.optionEmitter.emit(this.otherOptionText)
    } else {
      this.showOtherOptionInput = false;
      this.optionEmitter.emit(event)
    }
    this.openDropdown = false;
  }

  setOtherOptionText(text: string) {
    this.optionEmitter.emit(text)
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Verifica si el clic ocurrió dentro del dropdown usando el id único
    const element = document.getElementById(`${this.uniqueId}`);

    if (element && !element.contains(targetElement)) {
      this.openDropdown = false;
    }

  }
}
